import {useMutation, UseMutationResult, UseMutationOptions} from '@tanstack/react-query';
import {archiveUsers, register, restoreUsers, updateUser} from '../../../../service/authorization';
import {User, UserConfig, UserCreateDTO} from '../../../../incase-domain/user';

type MutationOptions = UseMutationOptions<{success: boolean}, unknown, string[]>;

export const useArchiveUsersMutation = (options?: MutationOptions): UseMutationResult<{success: boolean}, unknown, string[]> => {
    return useMutation({
        mutationFn: (userIds: string[]) => archiveUsers(userIds),
        ...options,
    });
};

export const useRestoreUsersMutation = (options?: MutationOptions): UseMutationResult<{success: boolean}, unknown, string[]> => {
    return useMutation({
        mutationFn: (userIds: string[]) => restoreUsers(userIds),
        ...options,
    });
};

type RegisterPayload = {user: UserCreateDTO; userConfig: UserConfig};
type RegisterResult = {success: boolean; errors?: Record<string, string[]>};

export const useRegisterUserMutation = (
    options?: UseMutationOptions<RegisterResult, unknown, RegisterPayload>
): UseMutationResult<RegisterResult, unknown, RegisterPayload> => {
    return useMutation({
        mutationFn: ({user, userConfig}) => register(user, userConfig),
        ...options,
    });
};

type UpdateUserPayload = {user: User; userConfig: UserConfig};
type UpdateUserResult = {success: true; user: User} | {success: false; errors?: Record<string, string[]>};

export const useUpdateUserMutation = (
    options?: UseMutationOptions<UpdateUserResult, unknown, UpdateUserPayload>
): UseMutationResult<UpdateUserResult, unknown, UpdateUserPayload> => {
    return useMutation({
        mutationFn: ({user, userConfig}) => updateUser(user, userConfig),
        ...options,
    });
};
